import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import PageHeader from "../../components/common/PageHeader";
import { getItem } from "../../context/actions/location";
import "./index.scss";
import ImagePlaceholderDetail from "../../components/common/ImagePlaceholderDetail";
import { capitalizeFirstLetter } from "../../utils/common";
import { tempAction } from "../../context/actions/tempAction";
const LocationDetail = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const parmId = useSelector((state) => state.general.paramId);
  const [resPayload, setResPayload] = useState();
  const role = useSelector((state) => state?.user?.user?.roles?.role?.roleName);
  const [userRole, setUserRole] = useState(role);

  useEffect(() => {
    let isMounted = true; // Add a boolean flag to track component mount state

    if (!userRole?.toLowerCase()?.includes("admin")) {
      history.push("/unauthorized");
    }

    return () => {
      isMounted = false; // Set the flag to false when the component unmounts
    };
  }, [userRole, history]);

  useEffect(() => {
    dispatch(tempAction({}));
  }, []);
  // whenever any status will update to get location items
  useEffect(() => {
    _getItems(parmId);
  }, [parmId]);

  /**
   * @description method call to get location
   */
  const _getItems = async (parmId) => {
    dispatch(
      getItem(parmId, (res) => {
        setResPayload(res);
      })
    );
  };
  return (
    <>
      <div className="page-wrapper">
        <PageHeader className="with-btn">
          <div className="left-col">
            <Button
              color="link"
              className="backBtn"
              onClick={() => {
                history.goBack();
              }}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </Button>
            {resPayload?.name && capitalizeFirstLetter(resPayload?.name)}
          </div>
        </PageHeader>
        <div className="inner-wrapper">
          <div className="location-dtl-wrapper">
            <div className="pic-cell position-relative">
              {/*<img className="img-fluid" src={require('../../assets/img/location/list-detail/pic-1.png')} alt="Detail View" />*/}
              {resPayload?.blob_name ? (
                <img
                  className="img-fluid"
                  src={resPayload?.blob_name}
                  alt="Detail View"
                />
              ) : (
                <ImagePlaceholderDetail />
              )}
            </div>
            <div className="inner">
              <div className="connect-blc">
                <label className="d-inline-flex mail">
                  <span>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>
                  <a href="mailto:abcd@gmail.com">{resPayload?.email}</a>
                </label>
                <label className="d-inline-flex ph">
                  <span>
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  <a href="tel:+1 408 123 4567">{resPayload?.phone}</a>
                </label>
              </div>
              <div className="info-cell">
                <h2>
                  {resPayload?.name && capitalizeFirstLetter(resPayload?.name)}
                </h2>
                <h3>
                  <span className="d-inline-flex align-items-center justify-content-center">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </span>
                  {resPayload?.address}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationDetail;
